import { useEffect, useRef } from "react";
import { SITE } from "@/lib/site";

/**
 * Inline Calendly embed.
 * Loads the widget.js script once and renders the booking widget.
 *
 * Props:
 *  - url: full Calendly URL (defaults to SITE.calendlyUrl)
 *  - height: pixel height (default 720)
 */
export default function CalendlyInline({ url, height = 720 }) {
  const containerRef = useRef(null);
  const widgetUrl = url || SITE.calendlyUrl;

  useEffect(() => {
    const SRC = "https://assets.calendly.com/assets/external/widget.js";
    const existing = document.querySelector(`script[src="${SRC}"]`);
    if (!existing) {
      const script = document.createElement("script");
      script.src = SRC;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div
      ref={containerRef}
      data-testid="calendly-inline-widget"
      className="calendly-inline-widget rounded-3xl overflow-hidden border border-white/10"
      data-url={widgetUrl}
      style={{ minWidth: "320px", height: `${height}px` }}
    />
  );
}
